export interface Category {
  id: string;
  name: string;
  slug: string;
  description: string;
  icon: string;
  count: number;
  coverImage: string;
}

export const categories: Category[] = [
  {
    id: 'c1',
    name: '热血冒险',
    slug: 'rexue-maoxian',
    description: '充满激情与挑战的热血冒险类漫画，主角不断成长突破自我，展开惊心动魄的旅程。包含战斗、友情、成长等经典元素，是最受欢迎的漫画类型之一。',
    icon: 'ri-fire-line',
    count: 12580,
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20anime%20manga%20style%20illustration%20with%20fiery%20action%20scene%2C%20adventure%20warrior%20with%20sword%20facing%20giant%20monster%2C%20dynamic%20composition%20with%20orange%20red%20warm%20colors%2C%20cinematic%20lighting%2C%20minimalist%20background&width=600&height=400&seq=cat-rexue-01&orientation=landscape',
  },
  {
    id: 'c2',
    name: '恋爱校园',
    slug: 'lianai-xiaoyuan',
    description: '描绘青春校园生活的纯爱漫画，细腻刻画少男少女间的甜蜜恋情与成长故事。从懵懂初恋到深情告白，每一页都充满青春的美好与感动。',
    icon: 'ri-heart-line',
    count: 9870,
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20illustration%20of%20high%20school%20couple%20under%20cherry%20blossom%20tree%2C%20soft%20pink%20pastel%20color%20palette%2C%20gentle%20spring%20lighting%2C%20emotional%20atmosphere%2C%20delicate%20art%20style&width=600&height=400&seq=cat-lianai-01&orientation=landscape',
  },
  {
    id: 'c3',
    name: '悬疑推理',
    slug: 'xuanyi-tuili',
    description: '扣人心弦的悬疑推理漫画，精妙的案件设置与出人意料的剧情反转。跟随主角一步步揭开真相，体验头脑风暴般的阅读快感。',
    icon: 'ri-search-eye-line',
    count: 6540,
    coverImage: 'https://readdy.ai/api/search-image?query=Mystery%20manga%20illustration%20with%20dark%20alley%20and%20silhouette%20detective%20figure%2C%20noir%20atmosphere%20with%20dramatic%20shadows%20and%20moody%20lighting%2C%20suspenseful%20composition%2C%20cool%20dark%20color%20tones&width=600&height=400&seq=cat-xuanyi-01&orientation=landscape',
  },
  {
    id: 'c4',
    name: '搞笑日常',
    slug: 'gaoxiao-richang',
    description: '轻松愉快的搞笑日常漫画，夸张的表情和幽默的桥段让人捧腹大笑。用诙谐的方式记录生活中的趣事，是解压放松的最佳选择。',
    icon: 'ri-emotion-laugh-line',
    count: 8320,
    coverImage: 'https://readdy.ai/api/search-image?query=Comedy%20slice%20of%20life%20manga%20illustration%20with%20colorful%20funny%20characters%20in%20everyday%20situations%2C%20bright%20cheerful%20colors%2C%20expressive%20chibi%20style%20faces%2C%20playful%20vibrant%20composition&width=600&height=400&seq=cat-gaoxiao-01&orientation=landscape',
  },
  {
    id: 'c5',
    name: '奇幻魔法',
    slug: 'qihuan-mofa',
    description: '天马行空的奇幻魔法世界，绚丽多彩的魔法战斗与神秘的异世界冒险。从剑与魔法到龙与地下城，带你进入无限想象的奇妙领域。',
    icon: 'ri-magic-line',
    count: 7890,
    coverImage: 'https://readdy.ai/api/search-image?query=Fantasy%20magic%20manga%20illustration%20with%20wizard%20casting%20spells%20in%20enchanted%20forest%2C%20glowing%20magical%20particles%2C%20mystical%20atmosphere%20with%20purple%20and%20gold%20accents%2C%20dreamy%20whimsical%20style&width=600&height=400&seq=cat-qihuan-01&orientation=landscape',
  },
  {
    id: 'c6',
    name: '科幻未来',
    slug: 'kehuan-weilai',
    description: '探索未来科技与宇宙奥秘的科幻漫画，机甲、太空、人工智能等元素交织出宏大的世界观。硬核科幻与人文思考的完美融合。',
    icon: 'ri-rocket-line',
    count: 4560,
    coverImage: 'https://readdy.ai/api/search-image?query=Sci-fi%20mecha%20manga%20illustration%20with%20futuristic%20city%20skyline%20and%20giant%20robot%2C%20neon%20lights%20and%20holographic%20displays%2C%20cyberpunk%20aesthetic%2C%20sleek%20metallic%20tones%20with%20vibrant%20accent%20colors&width=600&height=400&seq=cat-kehuan-01&orientation=landscape',
  },
  {
    id: 'c7',
    name: '恐怖惊悚',
    slug: 'kongbu-jingsong',
    description: '令人毛骨悚然的恐怖惊悚漫画，精心营造的恐怖氛围与出人意料的惊悚桥段。挑战你的心理承受极限，在恐惧中体验阅读的刺激。',
    icon: 'ri-ghost-line',
    count: 3210,
    coverImage: 'https://readdy.ai/api/search-image?query=Horror%20manga%20illustration%20with%20eerie%20abandoned%20house%20in%20moonlight%2C%20misty%20atmosphere%20with%20creepy%20shadows%2C%20dark%20monochromatic%20tones%20with%20subtle%20red%20accents%2C%20unsettling%20composition&width=600&height=400&seq=cat-kongbu-01&orientation=landscape',
  },
  {
    id: 'c8',
    name: '武侠古风',
    slug: 'wuxia-gufeng',
    description: '荡气回肠的武侠古风漫画，快意恩仇的江湖故事与侠骨柔情的人物刻画。精美的国风画工，呈现中国传统文化中的武侠精神与古典美学。',
    icon: 'ri-sword-line',
    count: 5420,
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20wuxia%20manga%20illustration%20with%20warrior%20on%20mountain%20peak%20at%20sunset%2C%20traditional%20hanfu%20clothing%2C%20ink%20wash%20painting%20style%2C%20elegant%20golden%20and%20vermilion%20tones%2C%20atmospheric%20mist&width=600&height=400&seq=cat-wuxia-01&orientation=landscape',
  },
];